import admin from './admin/text.js';
import agreement from './agreement/text.js';
import app from './app/text.js';
import auth from './auth/text.js';
import ecom from './ecom/text.js';
import fleet from './fleet/texts.js';
import home from './home/text.js';
import rms from './rms/texts.js';
import user from './user/text.js';

export default {
  admin,
  agreement,
  app,
  auth,
  ecom,
  fleet,
  home,
  user,
  rms,
};
